import moment from 'moment';
import { createSelector } from 'reselect';
import mappings from './mappings';

export const getRows = state => state.fileAvailability.rows;
export const getLoading = state => state.fileAvailability.loading;
export const getFilterDefinitions = state => state.fileAvailability.filterDefinitions;
export const getDefaultFilters = state => state.fileAvailability.defaultFilters;
export const getInitialised = state => state.fileAvailability.initialised;
export const getLastUpdated = state => state.fileAvailability.lastUpdated;
export const getDefaultSort = state => state.fileAvailability.gridSorting;

export const getDateFrom = (filters) => {
    if (filters) {
        const filter = filters.find(obj => obj.definition && obj.definition.id === 'runDate');
        if (filter && filter.value && filter.value.from) {
            return moment(filter.value.from, 'YYYYMMDD').format('YYYY-MM-DD');
        }
    }
    return null;
};

export const combinedColumnsSelector = createSelector(
    state => state.fileAvailability.columns,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);
